export enum IncidentSeverities {
  Severity_1 = 1,
  Severity_2 = 2,
  Severity_3 = 3,
  Severity_4 = 4,
  Severity_5 = 5,
}
